import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  icon: {},
});


function ListItem(props) {
  const { classes } = props;

  return (
    <MenuItem
      id={props.link}
      className={classes.menuItem}
      onClick={props.onClick}
    >
      <ListItemIcon className={classes.icon}>
        <Icon> {props.icon} </Icon>
      </ListItemIcon>
      <ListItemText classes={{ primary: classes.primary }} inset primary={props.title} />
    </MenuItem>
  );
}

ListItem.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListItem);



// WEBPACK FOOTER //
// ./src/components/modules/menus/MenuItem.js